import { ProductFeatures } from '@trello/product-features';
import { hasFreeBoardLimitDefined } from './hasFreeBoardLimitDefined';

export const freeBoardsUsed = <Team>(team: Team): number | undefined => {
  if (
    ProductFeatures.hasProduct(
      (team as { products?: number[] }).products?.[0],
    ) ||
    !hasFreeBoardLimitDefined(team)
  ) {
    return undefined;
  }

  const limit = team.limits.orgs.freeBoardsPerOrg;
  if (limit.count === undefined) {
    return undefined;
  }

  return limit.count;
};
